import { Component } from '@angular/core';
import {UserModel} from "../../../models/user.model";
import {catchError, of, Subscription, switchMap, tap} from "rxjs";
import {PromotionModel} from "../../../models/promotion.model";
import {PromotionService} from "../../../services/promotion.service";
import {TitleService} from "../../../services/title.service";
import {TranslateService} from "@ngx-translate/core";
import {ConfigService} from "../../../services/config.service";
import {AuthService} from "../../../services/auth.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss']
})
export class PromotionsComponent {
  brandName:string;
  assetsSource:string;

  titleTranslateSubs?: Subscription;

  publicPromotions: PromotionModel[] = [];

  token: string | null = null;
  tokenSubs?: Subscription;
  isLoading = true;

  promoSubs?: Subscription;
  eligiblePromotions: PromotionModel[] = [];
  activePromotions: PromotionModel[] = [];


  constructor(
    private configs: ConfigService,
    private authService: AuthService,
    private promoService: PromotionService,
    private titleService: TitleService,
    private translate: TranslateService,
    private toastr: ToastrService
  ) {
    this.brandName = this.configs.brandName;
    this.assetsSource = this.configs.assetsPath;

    this.titleTranslateSubs?.unsubscribe();
    this.titleTranslateSubs = this.translate.stream("PROMOTIONS.TITLE").subscribe(data => {
      this.titleService.setTitle(`Lobby / ${data}`);
    })

    this.publicPromotions = this.promoService.staticPromotions.filter(p => p.state === 'eligible');

    // this.userSubs = this.userService.userObject.subscribe((u: UserModel | null) => {
    //   this.user = u;
    //   // this.isLoading = true;
    //
    //   this.promoSubs?.unsubscribe();
    //
    //   if (this.user) {
    //     this.isLoading = true;
    //
    //     this.promoSubs = this.promoService.getUserPromos().subscribe({
    //       next: data => {
    //         this.isLoading = false;
    //         this.userPromotions = data.filter(p=>p.state === 'eligible');
    //         this.activePromotions = data.filter(p=>p.state === 'active');
    //         console.log(this.activePromotions)
    //       },
    //       error: err => {
    //         this.isLoading = false;
    //         console.error('Error fetching promotions:', err.message || err)
    //         this.userPromotions = []
    //         this.activePromotions = [];
    //       }
    //     })
    //
    //   } else {
    //     this.isLoading = false;
    //   }
    //
    // })


    this.tokenSubs = this.authService.token.pipe(
      tap(token => {
        this.token = token;
        this.isLoading = true;
      }),
      switchMap(token => token ? this.promoService.getUserPromos() : of([])),
      catchError(err => {
        // console.error('Error fetching promotions:', err.message || err);
        const errorMessageInToastr = err.message || err;
        this.toastr.error(errorMessageInToastr, this.translate.instant('PROMOTIONS.ERROR_MESSAGE'), {toastClass: 'ngx-toastr yourclass'})

        return of([]);
      })
    ).subscribe(data => {
      this.isLoading = false;

      // console.log(data)
      if (data.length){
        this.eligiblePromotions = data.filter(p => p.state === 'eligible');
        this.activePromotions = data.filter(p => p.state === 'active');
      }

    })


  }


  ngOnDestroy(): void {
    this.tokenSubs?.unsubscribe();
    this.promoSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();

  }

}



